import type { IBound } from '@blocksuite/global/utils';

import type { RoughCanvas, SurfaceElementModel } from '../../index.js';
import type { Renderer } from '../renderer.js';
import { attachmentChip } from './attachment-chip.js';
import { brush } from './brush/index.js';
import { connector } from './connector/index.js';
import { group } from './group/index.js';
import { mindmap } from './mindmap.js';
import { mindmapHighlight } from './mindmap-highlight.js';
import { getCustomRenderers } from './registry.js';
import { shape } from './shape/index.js';
import { text } from './text/index.js';
import { collectionBubble } from './collection-bubble.js';
export { normalizeShapeBound } from './shape/utils.js';

export type ElementRenderer<
  T extends BlockSuite.SurfaceElementModel = SurfaceElementModel,
> = (
  model: T,
  ctx: CanvasRenderingContext2D,
  matrix: DOMMatrix,
  renderer: Renderer,
  rc: RoughCanvas,
  viewportBound: IBound
) => void;

export const modelRenderer = {
  brush,
  connector,
  group,
  shape,
  text,
  mindmap,
  'collection-bubble': collectionBubble,
  'attachment-chip': attachmentChip,
  'mindmap-highlight': mindmapHighlight,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ...getCustomRenderers(),
} as Record<string, ElementRenderer<any>>;
